import React, { useContext } from "react";
import { injectIntl } from "react-intl";

import DisplayOptions from "wxrecall/components/SearchResults/DisplayOptions";
import { AppContext } from "wxrecall/components/App";

function SearchControls(props) {
  const appContext = useContext(AppContext);
  const colSize = appContext.mobile ? "span12" : "span6";
  return (
    <div className="row-fluid search-result-controls">
      <DisplayOptions {...props} mobile={appContext.mobile} />
    </div>
  );
}

export default injectIntl(SearchControls);
